import JobListingsView from './job_listings_view';

const JobListings = JobListingsView;
export default JobListings;
